import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-exercise-completion',
  templateUrl: './exercise-completion.component.html',
  styleUrls: ['./exercise-completion.component.css']
})
export class ExerciseCompletionComponent implements OnInit {
  exerciseResultData:any;
  exerciseData:any;
  accuracy:any;
  userInfo:any;
  userId:any;
  topicdata:any;
  isLastTopic:any;
  isFromSolutionPage:any;
  constructor(public selfLearnService: SelfLearnService,public spinner:NgxSpinnerService,public router: Router,) {

   }

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = this.userInfo.userDto.userId;
    this.exerciseResultData = JSON.parse(localStorage.getItem('examresultData'));
    this.topicdata = JSON.parse(localStorage.getItem('selctedChapterTopics'));
    let topicId = this.selfLearnService.getTopicId();
    this.isLastTopic = this.topicdata[this.topicdata.length-1].topicId == Number(topicId) ? true :false;
    this.isFromSolutionPage = localStorage.getItem('isFromSolutionPage');


  }
  reattemptNow(){
    this.spinner.show();
    localStorage.removeItem('exerciseQuestions');
    localStorage.removeItem('exerciseData');

      this.selfLearnService.getExerciseExamDetails().subscribe((res:any) =>{
        this.exerciseData = res.report
        this.exerciseData = this.exerciseData[this.exerciseData.length-1];
        this.accuracy = this.exerciseData.attemps.length > 0?this.exerciseData.attemps[this.exerciseData.attemps.length-1]: []
        this.exerciseData.attemptnumber = this.exerciseData.attemps.length > 0? Number(this.exerciseData.attemps[this.exerciseData.attemps.length-1].attemptnumber)+1 : 1
        localStorage.setItem('exerciseData',JSON.stringify(this.exerciseData));
        this.spinner.hide();
        this.router.navigate([`selfLearn-V2/exercise-questions`]);
      });
  }
  goToNextTopic(){
    let rowIndex = Number(localStorage.getItem('learnTabExpandIndex'))
    localStorage.setItem('learnTabExpandIndex',this.isLastTopic ? '1': ((rowIndex+1)+''));
    this.router.navigate([`selfLearn-V2/chapter`]);
  }
  
  viewSolutionForExercise(){
    let viweSolutionPayload:any =   JSON.parse(localStorage.getItem('viweSolutionPayload'));
    viweSolutionPayload =   {
      ...viweSolutionPayload,
      "attempt":this.exerciseResultData.attempt,  
    }
    localStorage.setItem('viweSolutionPayload',JSON.stringify(viweSolutionPayload));
    this.router.navigate([`selfLearn-V2/exercise-solution`]);
  }
}
